export const DefaultRewardProgramName = 'Rewards';

// In Canada it is illegal to reference 'rewards'
export const CanadianDefaultRewardProgramName = 'Member Club';
